import { Outlines } from "@react-three/drei";
import { PREVIEW_DESTINATION_OUTLINE_COLOR } from "../utils/viewportCanvasDefaults";

/** Drei Outlines must be a direct child of mesh / skinnedMesh / instancedMesh. */
export function PreviewDestinationOutlines() {
  return (
    <Outlines
      color={PREVIEW_DESTINATION_OUTLINE_COLOR}
      thickness={0.015}
      angle={Math.PI}
      screenspace
      transparent={false}
      opacity={1}
    />
  );
}
